export const fieldAliases = {
  'Variables Granulometricas': {
    id: 'ID',
    arena: 'Arena (%)',
    limo: 'Limo (%)',
    arcilla: 'Arcilla (%)',
  },
  'Cartas de Suelo': {
    simbolo: 'Símbolo',
    cap: 'Capacidad de Uso',
    clase: 'Clase',
    subclase: 'Subclase',
    ip: 'Índice de Productividad',
  },
};